import { firestore } from '@src/api/Firebase/Firebase';
import { collection } from 'firebase/firestore';

export enum ProfileTypes {
    Admin = 'admin',
    /** Admin de sucursal: lo del admin, acotado a sus sucursales (PLAN-GASTOS-Y-ADMIN-DE-SUCURSAL §4). */
    BranchAdmin = 'branchAdmin',
    Manager = 'manager',
    Collaborator = 'collaborator',
    DistributionCenter = 'distributionCenter'
}

export interface UserProfileType {
    status: boolean;
    profile: ProfileTypes;
    firstname: string;
    lastname: string;
    name: string;
    phone: string;
    branchOffices: string[];
    address: string;
    photo?: string;
}

export interface UserType {
    uid: string;
    createdAt: any;
    profile: UserProfileType;
    email: string;
}

/**
 * ¿Puede entrar este usuario? **Desactivar a alguien lo saca del sistema.**
 *
 * Hasta el 2026-09-27 `profile.status` solo pintaba el foquito de la lista: nadie
 * lo leía al entrar, así que un usuario "desactivado" seguía trabajando. Solo un
 * `false` explícito cierra la puerta — un doc viejo sin el campo sigue entrando.
 */
export const isUserActive = (user?: Pick<UserType, 'profile'> | null): boolean => user?.profile?.status !== false;

export const INACTIVE_USER_MESSAGE = 'Tu usuario está desactivado. Pide a un administrador que lo reactive.';

export const USER_COLLECTION = 'users';

export const usersRef = collection(firestore, USER_COLLECTION);
